export const EstadoDocumento = Object.freeze({
    PENDIENTE: "PENDIENTE",
    CARGADO: "CARGADO",
    GENERADO: "GENERADO",
    ERROR: "ERROR"
});
